<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addFunctionalHelp()"
                    matTooltip="{{ 'add_record' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setNameFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <pixl-consumer-cb (onStateChange)="setConsumerFilter($event)" />
                    </div>

                    <div class="filter-item">
                        <pixl-competency-cb (onStateChange)="setCompetencyFilter($event)" />
                    </div>

                    <div class="filter-item">
                        <pixl-type-cb
                            (onStateChange)="setKindFilter($event)"
                            matLabelText="{{ 'type' | transloco }}"
                        />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="edit-actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editFunctionalHelp(functionalHelp)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Copy"
                        (click)="copyFunctionalHelp(functionalHelp)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                        (click)="confirmDelete(functionalHelp)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ functionalHelp.name }}</td>
            </ng-container>
            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "application" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ functionalHelp?.getConsumer()?.name || "---" }}</td>
            </ng-container>
            <ng-container matColumnDef="exerciseKind">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "type" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >
                    <pixl-lang
                        [key]="functionalHelp.exerciseKind"
                        [keySuffix]="functionalHelp.exerciseSubKind?.toString()"
                    ></pixl-lang>
                </td>
            </ng-container>
            <ng-container matColumnDef="competency">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "subject" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ functionalHelp?.getCompetency()?.name || "---" }}</td>
            </ng-container>
            <ng-container matColumnDef="created">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let functionalHelp"
                >{{ getCreatedDate(functionalHelp.id) | date }}</td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>

        <pixl-main-pagination [pageChangeCallback]="paginationChanged"></pixl-main-pagination>
    </div>
</div>